import { MultiSelectItem, ItemStateType } from ".";

export class SelectChangeEventArgs {
  
  targetItem: MultiSelectItem;

  selectedItems: Array<MultiSelectItem> = [];

}